module.exports = __webpack_public_path__ + "in.7fdfdb85.svg";